import deleteTrigger from '@/API/Triggers/deleteTrigger';
import { useMutation } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

const useDeleteTrigger = (triggerId, resetToMainTable, onClose) => {
    const { currentScope } = useSelector((state) => state.login);

    return useMutation({
        mutationKey: ['deleteTrigger', triggerId],
        mutationFn: async () => {
            try {
                await deleteTrigger({ triggerId, scope: currentScope });
                toast.success('Trigger deleted successfully!');
                return { success: true };
            } catch (error) {
                const errorMessage = `Failed to delete trigger: ${error}`;
                toast.error(errorMessage);
                throw error;
            }
        },
        onSuccess: () => {
            if (resetToMainTable) {
                resetToMainTable();
            }
            if (onClose) {
                onClose();
            }
        },
        onError: (error) => {
            console.error('Delete operation failed:', error);
        },
    });
};

export default useDeleteTrigger;
